function useTitle(title: string) {
  if (title === '') {
    document.title = 'Saltus Oneview';
  } else if (document.title !== title) {
    document.title = `${title} - Saltus Oneview `;
  }
}

export default typeof document !== 'undefined' ? useTitle : (_title: string) => {};
